var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.user)?_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('MainLogo'),_c('v-card',{staticClass:"elevation-20"},[_c('Form')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }